import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../components/AuthContext";
import Swal from "sweetalert2";
import LeftSidebar from './LeftSidebar';
import Topbar from './Topbar';
import Footer from './Footer';
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from '../Config';
const ChangePassword = () => {
     const navigate = useNavigate();
    const { user, logout } = useAuth();
    const uid = localStorage.getItem("user_id");
    const [ formData, setFormData] = useState({
        cpassword:"",
        npassword:"",
        cnpassword:""
    });
 const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [ validationErrors, setValidationErrors] = useState({});

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    }

    const handleSubmit = async(e) => {
        e.preventDefault();
        console.log(uid)
        const token = localStorage.getItem('token');
        const errors = {};

        if(!formData.cpassword.trim()){
            errors.cpassword = "Current Password is Required";
        }
        if(!formData.npassword.trim()){
            errors.npassword = "New Password is Required";
        }
        if(!formData.cnpassword.trim()){
            errors.cnpassword = "Confirm New Password is Required";
        }else if(formData.npassword !== formData.cnpassword){
            errors.cnpassword = "New Password and Confirm New Password Is Not Match";
        }

        if(Object.keys(errors).length > 0 ){
            setValidationErrors(errors);
            return;
        }

        try{
            const response = await axios.post(`${BASE_URL}/api/changememberpassword`,{
                ...formData,
                userId:uid
            },{
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.status === "success") {
                Swal.fire({
                    icon: "success",
                    title: "Change Password",
                    text: "Password Change successfully",
                }).then(() => {
                    logout();
                });
                
                
            } else {
                Swal.fire({
                    icon: "error",
                    title: "CHange Password Failed",
                    text: response.data.message || "An error occurred while processing your request. Please try again later.",
                });
            }
            
        }catch(error){
            Swal.fire({
                icon: "error",
                title: "Change Password Failed",
                text: "An error occurred while processing your request. Please try again later.",
            });
        }

    }   
    const imagePath = process.env.PUBLIC_URL + '/images/bg-image.webp';
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };
    return (
    <>
        <div id="page-top">
            <div id="wrapper">
                <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                <div id="content-wrapper" classNameName="d-flex flex-column">
                    <div id="content">
                        <Topbar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                        <div classNameName="container-fluid">
                            <div className='row'>
                            <div classNameName='col-md-12'>
                                <div classNameName='card'>
                                    <div classNameName='card-header py-3' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                        <div classNameName='row'>
                                            <div classNameName='col-md-6 d-flex left-content-end'>
                                                <h6 classNameName="font-weight-bold text-primary left" style={{textAlign: 'left',
    margin: '0 11px 16px',color:'#050505',fontWeight: '800'}}>Change Password</h6>
                                            </div>
                                            <div classNameName='col-md-6 d-flex justify-content-end'>
                                                <i classNameName="fa fa-arrow-left" onClick={() => navigate(-1)}></i>
                                            </div>
                                        </div>
                                    </div>
           
                            <div className="col-6 col-md-6 col-lg-6 col-xl-9">
                                <div className="card" style={{borderRadius: '15px'}}>
                                    <div className="card-body p-5">
                                       
                                        <form method="POST" onSubmit={handleSubmit}>
                                            
                                            <div className="form-outline mb-4">
                                                <input type="password" name="cpassword" placeholder="Enter current Password" className="form-control" onChange={handleChange} />
                                                {validationErrors.cpassword && <span className="text-danger">{validationErrors.cpassword}</span>}
                                            </div>
                                            <div className="form-outline mb-4">
                                                <input type="password" name="npassword" placeholder="Enter New Password" className="form-control" onChange={handleChange} />
                                                {validationErrors.npassword && <span className="text-danger">{validationErrors.npassword}</span>}
                                            </div>
                                            <div className="form-outline mb-4">
                                                <input type="password" name="cnpassword" placeholder="Enter Confirm New Password" className="form-control" onChange={handleChange} />
                                                {validationErrors.cnpassword && <span className="text-danger">{validationErrors.cnpassword}</span>}
                                            </div>
                                            
                                            <button type="submit" className="btn btn-primary mt-4">Submit</button>
                                        </form>
                                        
                                        
                                    </div>
                                </div>
                            </div>
                        
            </div>
            </div>
                                </div>
                            </div>
                         </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            
        
    </>
    );
};

export default ChangePassword;
